<template>
  <div class='receipt'>
    <el-dialog title="手填快递单号" :visible.sync="dialogFormVisible">
      <el-form :model="form" :label-width="160">
        <el-form-item label="快递单号">
          <el-input v-model="form.LogisticCode" autocomplete="off" clearable></el-input>
        </el-form-item>
        <!-- <el-form-item label="快递公司">
          <el-select v-model="form.cSCName">
            <el-option v-for="item in expressList" :key="item.cname" :value="item.cname"
                       :label="item.cname"></el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="onClickInputExpressConfirm">确 定</el-button>
      </div>
    </el-dialog>

    <!--打印需要的元素-->
    <div v-show="false" style="
        position: fixed;
        left: calc(50% - 200px);
        top: 50px;
        background-color: rgb(65, 65, 65);
        padding: 30px 20px;
      ">
      <iframe ref="pringContent" id="print-content" width="400px" height="600px"
              frameborder="0"></iframe>
    </div>

    <div class="header" style="background: linear-gradient(to right, #3fa2b3, #ffffff);">
      请在扫码枪使用期间，不要使用电脑；取消操作请到后台订单列表
    </div>
    <div class="flex-center express-list">
      <div class="header" style="border: none; background: none">
        寄发票：当前已配置快递
      </div>
      <div class="flex-center">
        <div v-if="expressList.length == 0">配置失败，请使用按钮进入</div>
        <div v-else class="item" v-for="item in expressList" :key="item.id">
          <el-image style="
              width: 40px;
              height: 40px;
              border: 1px solid rgb(110, 110, 110);
            " :src="item.img" fit="fill"></el-image>

          <div class="express-title">{{ item.cname }}</div>
        </div>
      </div>
    </div>

    <!--发票列表-->
    <div style="margin-top: 30px; overflow: hidden; border-radius: 10px">
      <el-table :data="erpDataList" style="width: 100%" stripe border>
        <el-table-column label="发票号码" prop="code" width="120"></el-table-column>
        <el-table-column label="发票日期" prop="date" width="120"></el-table-column>
        <el-table-column label="部门" width="80">
          <template slot-scope="scope">
            <el-tooltip effect="dark" :content="scope.row.info.cdepname" placement="top-start">
              <div class="one-row-text">
                {{ scope.row.info.cdepname }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="业务员" width="80">
          <template slot-scope="scope">
            <el-tooltip effect="dark" :content="scope.row.info.cPsn_Name" placement="top-start">
              <div class="one-row-text">
                {{ scope.row.info.cPsn_Name }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="客户" width="240">
          <template slot-scope="scope">
            <el-tooltip effect="dark" :content="scope.row.info.cCusName" placement="top-start">
              <div class="one-row-text">
                {{ scope.row.info.cCusName }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- <el-table-column label="发货仓库" width="100">
          <template slot-scope="scope">
            <el-tooltip effect="dark" :content="scope.row.info.cWhName" placement="top-start">
              <div class="one-row-text">
                {{ scope.row.info.cWhName }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column> -->
        <el-table-column label="发货方式" width="80">
          <template slot-scope="scope">
            <el-tooltip effect="dark" :content="scope.row.info.cSCName" placement="top-start">
              <div class="one-row-text">
                {{ scope.row.info.cSCName }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="地址" width="200">
          <template slot-scope="scope">
            <el-tooltip effect="dark" :content="
                scope.row.info.SHENGFEN +
                scope.row.info.CHENGSHI +
                scope.row.info.QUXIAN +
                scope.row.info.CADDRESS
              " placement="top-start">
              <div class="one-row-text">
                {{
                  scope.row.info.SHENGFEN +
                  scope.row.info.CHENGSHI +
                  scope.row.info.QUXIAN +
                  scope.row.info.CADDRESS
                }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="收货人" width="80">
          <template slot-scope="scope">
            <el-tooltip effect="dark" :content="scope.row.info.cCusPerson" placement="top-start">
              <div class="one-row-text">
                {{ scope.row.info.cCusPerson }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="收货人联系方式" width="140">
          <template slot-scope="scope">
            <el-tooltip effect="dark" :content="scope.row.info.cMobilePhone" placement="top-start">
              <div class="one-row-text">
                {{ scope.row.info.cMobilePhone }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button style="margin: 5px 3px" type="info" size="small"
                       @click="onClickInputExpressNo(scope.row, scope.$index)">
              手动更换快递单号</el-button>
            <el-button style="margin: 5px 3px"
                       v-if="scope.row.rehtml == null || scope.row.rehtml == ''" type="warning"
                       size="small" @click="onClickGetExpress(scope.row, scope.$index)">
              生成快递单</el-button>
            <el-button v-if="
                scope.row.rehtml != '' && scope.row.rehtml != null
              " style="margin: 5px 3px" type="success" size="small"
                       @click="onClickPrint(scope.row)">打印</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "receipt",
  props: {},
  data() {
    return {
      admin_id: "",
      erpDataList: [],
      form: {
        index: 0, //数组中的下标
        cSysBarCode: "", //发货单编码
        id: "", //订单id
        LogisticCode: "", //快递单号
        cSCName: "",
      },
      dialogFormVisible: false,
    };
  },
  computed: {
    ...mapGetters(["scanList", "expressList"]),
  },
  watch: {
    scanList(val) {
      let code = val[val.length - 1];
      let isReceipt = this.$tool.isReceipt(code);

      //判断扫的是不是发票
      if (isReceipt) {
        let receiptList = code.split(",");
        var date = receiptList[5].trim() + "";
        let receipt_code = receiptList[3].trim();
        let year = date.slice(0, 4);
        let mon = date.slice(4, 6);
        let day = date.slice(6, 8);
        date = year + "-" + mon + "-" + day;

        this.requestGetReceipt(receipt_code, date);
      } else this.$message.error("该二维码非发票，请移步至订单发货页面");
    },
  },
  methods: {
    //手动输入快递单号
    onClickInputExpressNo: function (obj, index) {
      this.form = {
        cSysBarCode: obj.cSysBarCode,
        index: index,
        id: obj.id,
        LogisticCode: "",
      };
      this.dialogFormVisible = true;
    },
    //生成快递面单
    onClickGetExpress: async function (obj, index) {
      let expressName = obj.info.cSCName;
      if (expressName == "") {
        this.$message.error("抱歉，没有发货方式，请业务员补充发货发送");
        return;
      }

      let type = this.$tool.expressNameToExpressType(expressName);
      let payType = this.$tool.expressNameToPayType(expressName);
      console.log(type + " " + payType);

      let expressId = "";
      for (var i = 0; i < this.expressList.length; i++) {
        let express = this.expressList[i];
        if (type == express["abbreviation"] && payType == express["paytype"]) {
          expressId = express["id"];
          break;
        }
      }

      if (expressId == "") {
        this.$message.error(
          "抱歉，暂时只支持顺丰、申通、德邦、京东、京东快运，如要使用其他快递，请联系管理人员"
        );
        return;
      }

      let params = {
        id: obj.id,
        ShipperCode: type,
        store_id: this.admin_id,
        express_id: expressId,
      };
      let result = await this.requestGetExpress(params);

      if (result[0]) {
        var list = [].concat(this.erpDataList);
        list[index].rehtml = result[1];
        this.erpDataList = list;

        this.$message({
          message: "快递面单生成成功",
          type: "success",
        });
      } else this.$message.error(result[1]);
    },
    onClickInputExpressConfirm: function () {
      this.requestInputExpress();
    },
    //点击打印
    onClickPrint: function (obj) {
      this.$refs.pringContent.setAttribute("srcdoc", obj.rehtml);

      setTimeout(() => {
        var iframe = document.getElementById("print-content");
        // iframe.contentWindow.focus();
        iframe.contentWindow.print();
      }, 1500);
    },
    requestGetReceipt(code, date) {
      let _this = this;
      this.$http
        .post("/api/get_ording_by_invoice", {
          invoice_code: code,
          dDate: date,
          admin_id: this.admin_id,
        })
        .then((res) => {
          if (res.data.code == 1001 || res.data.code == 1002) {
            var item = res.data.data;
            item.code = code;
            item.date = date;
            if (item.erp_data.length > 0) item.info = item.erp_data[0];
            _this.erpDataList.push(item);
            console.log(item);
          } else _this.$message.error(res.data.message);
        })
        .catch((err) => {});
    },
    //申请快递面单
    requestGetExpress: function (params) {
      if (params.ShipperCode == "JDKY") {
        params.TransType = 3;
        params.ExpType = 6;
        params.Weight = 0.1;
        params.Volume = 0.05;
      } else if (params.ShipperCode == "JD") {
        params.TransType = 1;
        params.ExpType = 6;
        params.Weight = 0.1;
        params.Volume = 0.05;
      }
      
      let _this = this;
      console.log(params);

      return new Promise((resolve) => {
        _this.$http
          .post("api/get_data", params)
          .then((res) => {
            if (res.data.code == 1001) {
              resolve([true, res.data.data.PrintTemplate]);
            } else resolve([false, res.data.message]);
          })
          .catch((err) => {
            resolve([false, "服务器出错"]);
          });
      });
    },
    //手填快递单号
    requestInputExpress: function () {
      let _this = this;

      this.$http
        .post("api/update_order_logisticcode", {
          LogisticCode: this.form.LogisticCode,
          order_id: this.form.id,
          cSCName: this.form.cSCName,
        })
        .then(async (res) => {
          if (res.data.code == 1001) {
            _this.dialogFormVisible = false;
            _this.erpDataList.splice(_this.form.index, 1);
            _this.$message({
              message: result[1],
              type: "success",
            });
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          // _this.$message.error("服务器出错");
        });
    },
    ...mapActions(["setScanList"]),
  },
  //创建完成（可以访问当前this实例）
  created() {
    if (this.$route.query["admin_id"]) {
      this.admin_id = this.$route.query["admin_id"];
      localStorage.setItem("admin_id", this.$route.query["admin_id"]);
    }
    if (localStorage.getItem("admin_id"))
      this.admin_id = localStorage.getItem("admin_id");

    // this.setScanList([",,,09204384,,20211029,,,"]);
    this.setScanList([",,,09311293,,20211029,,,"]);
  },
  //挂载完成（可以访问DOM元素）
  mounted() {},
  //beforeCreate() {}, //创建之前
  //beforeMount() {}, //挂载之前
  //beforeUpdate() {}, //更新之前
  //updated() {}, //更新之后
  //beforeDestroy() {}, //销毁之前
  //destroyed() {}, //销毁完成
  //activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.receipt {
}
</style>


// WEBPACK FOOTER //
// src/components/receipt.vue